<template>
  <div
    class="weui-container weui-global-dom"
    id="halfSelfDialog"
    :class="visible && isShowMask ?'weui-global-dom-active':''"
    @click="handleClickMask"
    ref="mask"
    role="dialog" :tabindex="tabIndex" aria-modal="true"
  >
    <div
      class="weui-half-screen-dialog weui-slide"
      :class="{ 'weui-slide-active': visible, 'no-mask': !isShowMask }"
    >
      <div class="weui-half-screen-dialog__hd" v-if="!hideHeader">
        <div class="weui-half-screen-dialog__hd__side" v-if="isShowClose">
          <div class="weui-icon-btn weui-icon-btn_close" @click="onClose" role="button"
          :aria-label="closeAriaLabel"></div>
        </div>
        <div class="weui-half-screen-dialog__hd__main">
          <strong class="weui-half-screen-dialog__title">{{title}}</strong>
        </div>
      </div>
      <div class="weui-half-screen-dialog__bd" ref="content">
        <slot name="bd"></slot>
        <slot></slot>
      </div>
      <div class="weui-half-screen-dialog__ft" v-if="$slots.ft">
        <slot name="ft"></slot>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { disableBodyScroll, enableBodyScroll } from '../../../common/scroll';

export default Vue.extend({
  name: 'FitHalfScreenDialog',
  props: {
    /** 标题 */
    title: String,
    /** 关闭按钮提示文案 */
    closeAriaLabel: {
      type: String,
      default: '關閉',
    },
    /** tab键序号 */
    tabIndex: {
      type: Number,
      default: -1,
    },
    /** 是否打开 */
    visible: Boolean,
    /** 是否可以点击遮罩层关闭 */
    maskClose: {
      type: Boolean,
      default: true,
    },
    /** 是否隐藏标题区域 */
    hideHeader: {
      type: Boolean,
      default: false,
    },
    /** 是否将DOM移至body中 */
    appendToBody: {
      type: Boolean,
      default: false,
    },
    /** 是否展示关闭按钮 */
    isShowClose: {
      type: Boolean,
      default: true,
    },
    /** 是否展示遮罩层 */
    isShowMask: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    visible(newValue) {
      if (newValue) {
        disableBodyScroll();
      } else {
        enableBodyScroll();
      }
    },
  },
  methods: {
    onClose() {
      this.$emit('onClose');
    },
    handleClickMask(e: Event) {
      e.stopPropagation();
      // @ts-ignore
      if (e?.target?.id === 'halfSelfDialog') {
        if (this.maskClose) {
          this.onClose();
        }
      }
    },
    stop(e: Event) {
      e.preventDefault();
    },
  },
  mounted() {
    if (this.appendToBody) {
      document.body.appendChild(this.$el);
    }
  },
  destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.appendToBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    enableBodyScroll();
  },
});
</script>
